<template><!-- svgo-optimised -->
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_4867_21318)">
    <path d="M21.2101 18.46L13.3201 3.69C13.0901 3.27 12.6601 3 12.1801 3C11.7001 3 11.2601 3.26 11.0401 3.69L3.15012 18.46C2.93012 18.87 2.95012 19.34 3.18012 19.74C3.42012 20.13 3.83012 20.37 4.29012 20.37H20.0501C20.5101 20.37 20.9301 20.13 21.1601 19.74C21.4001 19.35 21.4101 18.87 21.1901 18.46H21.2101ZM4.64012 18.87L12.1801 4.73L19.7201 18.87H4.64012Z" fill="#333333"/>
    <path d="M11.4299 8.45001V14.95C11.4299 15.36 11.7699 15.7 12.1799 15.7C12.5899 15.7 12.9299 15.36 12.9299 14.95V8.45001C12.9299 8.04001 12.5899 7.70001 12.1799 7.70001C11.7699 7.70001 11.4299 8.04001 11.4299 8.45001Z" fill="#333333"/>
    <path d="M12.1801 16.32C11.7201 16.32 11.3501 16.69 11.3501 17.15C11.3501 17.61 11.7201 17.98 12.1801 17.98C12.6401 17.98 13.0101 17.61 13.0101 17.15C13.0101 16.69 12.6401 16.32 12.1801 16.32Z" fill="#333333"/>
  </g>
  <defs>
    <clipPath id="clip0_4867_21318">
      <rect width="18.36" height="17.37" fill="white" transform="translate(3 3)"/>
    </clipPath>
  </defs>
</svg>
</template>